import React from 'react';

export default function CatTailSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="15.24,27.4 7.32,27.4 14.01,8.42 21.93,8.42" fill="#727081" />
      <polygon points="12.34,2.0 20.26,2.0 21.93,8.42 14.01,8.42" fill="#A6A5B1" opacity="0.92" />
      <polygon points="7.32,27.4 5.64,20.98 12.34,2.0 14.01,8.42" fill="#41404A" opacity="0.95" />
      <polygon points="31.03,37.16 23.13,37.16 23.13,29.27 31.03,29.27" fill="#727081" />
      <polygon points="23.13,37.16 31.03,37.16 24.71,34.0 16.82,34.0" fill="#41404A" opacity="0.95" />
      <polygon points="23.13,37.16 16.82,34.0 16.82,26.11 23.13,29.27" fill="#41404A" opacity="0.95" />
      <polygon points="32.68,38.0 24.83,38.0 26.5,33.26 34.36,33.26" fill="#727081" />
      <polygon points="23.15,20.42 31.01,20.42 34.36,33.26 26.5,33.26" fill="#A6A5B1" opacity="0.92" />
      <polygon points="24.83,38.0 21.48,25.16 23.15,20.42 26.5,33.26" fill="#41404A" opacity="0.95" />
    </svg>
  );
}
